module.exports = __webpack_public_path__ + "img/qy.60370b8e.svg";